module.exports = __webpack_public_path__ + "img/onegate.27cba815.jpg";